import http from "@/service/util/http.js";
import { SysConfig, PageConfig, CommonCode } from "@/env/SysConfig.js";

const SHIPWORK_DOMAIN = "https://www.shipwork.net";
const commonApi = {
  getToken: async function(params) {
    return await http.post(
      `${SHIPWORK_DOMAIN}/api/login?client_id=${SysConfig.clientId}`,
      params
    );
  },
  getUserConfig: async function() {
    return await http.get(`${SHIPWORK_DOMAIN}/api/userInfoes/me/config`);
  },
  getCommonGroup: async function() {
    return await http.get("/commonCodeGroups");
  },
  getCommonDetail: async function() {
    return await http.get("/commonCodeDetails");
  },
};
export { commonApi as default };
